import { EmptyState } from './StatusIndicator'
import { formatBytes } from './format'
import type { ProcessRow } from '../../types/monitoring'

function ProcessTable({ title, rows, metricLabel, metricKey }: {
  title: string; rows: ProcessRow[]; metricLabel: string; metricKey: 'cpu_percent' | 'memory_percent'
}) {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-neutral-200 p-6">
      <h2 className="font-bold text-secondary mb-4">{title}</h2>
      {!rows.length ? (
        <EmptyState />
      ) : (
        <div className="overflow-x-auto -mx-2">
          <table className="w-full text-sm border-separate border-spacing-0">
            <thead>
              <tr className="text-left">
                <th className="py-2 px-2 text-neutral-400 font-medium text-xs uppercase tracking-wide">PID</th>
                <th className="py-2 px-2 text-neutral-400 font-medium text-xs uppercase tracking-wide">Process</th>
                <th className="py-2 px-2 text-neutral-400 font-medium text-xs uppercase tracking-wide">User</th>
                <th className="py-2 px-2 text-neutral-400 font-medium text-xs uppercase tracking-wide text-right">{metricLabel}</th>
                <th className="py-2 px-2 text-neutral-400 font-medium text-xs uppercase tracking-wide text-right">RSS</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((p) => (
                <tr key={p.pid} className="hover:bg-neutral-50 transition-colors">
                  <td className="py-2 px-2 border-t border-neutral-100 text-neutral-500 tabular-nums">{p.pid}</td>
                  <td className="py-2 px-2 border-t border-neutral-100 font-medium text-neutral-800 truncate max-w-[140px]">{p.name}</td>
                  <td className="py-2 px-2 border-t border-neutral-100 text-neutral-500 truncate max-w-[100px]">{p.username || '—'}</td>
                  <td className="py-2 px-2 border-t border-neutral-100 text-right font-semibold text-neutral-700 tabular-nums">
                    {metricKey === 'cpu_percent' ? `${p.cpu_percent.toFixed(1)}%` : `${p.memory_percent.toFixed(1)}%`}
                  </td>
                  <td className="py-2 px-2 border-t border-neutral-100 text-right text-neutral-500">{formatBytes(p.rss_bytes)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}

export function ProcessTables({ topCpu, topMemory, loading }: {
  topCpu: ProcessRow[]; topMemory: ProcessRow[]; loading: boolean
}) {
  if (loading) {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="h-64 bg-neutral-100 rounded-2xl animate-pulse" />
        <div className="h-64 bg-neutral-100 rounded-2xl animate-pulse" />
      </div>
    )
  }
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <ProcessTable title="Top CPU-Consuming Processes" rows={topCpu} metricLabel="CPU" metricKey="cpu_percent" />
      <ProcessTable title="Top Memory-Consuming Processes" rows={topMemory} metricLabel="Mem" metricKey="memory_percent" />
    </div>
  )
}
